import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import logger from 'redux-logger';
import { authApi } from '_services/auth';
import { documentsApi } from '_services/documents';
import { userApi } from '_services/user';
import { refApi } from '_services/ref';
import { spellcheckerApi } from '_services/spellchecker';
import { myRefApi } from '_services/myref';
import { myRefGroupsApi } from '_services/myrefgroups';
import { snapshotApi } from '_services/snapshot';



export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // .concat(logger)
      .concat(authApi.middleware)
      .concat(documentsApi.middleware)
      .concat(userApi.middleware)
      .concat(refApi.middleware)
      .concat(myRefApi.middleware)
      .concat(myRefGroupsApi.middleware)
      .concat(spellcheckerApi.middleware)
      .concat(snapshotApi.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
